import { Component, OnInit,OnDestroy } from '@angular/core';
import { ApiserviceService } from '../apiservice.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})


export class HomeComponent implements OnInit, OnDestroy {

  channel:any;
  movies:any[]=[];
  trend:any[]=[];

  imgPrefix:string="https://image.tmdb.org/t/p/w500";
  

  pageNumber:any;

 
  constructor(private _ApiserviceService:ApiserviceService, private _ActivatedRoute:ActivatedRoute, private _Router:Router) { 
    
   
    this.pageNumber=this._ActivatedRoute.snapshot.paramMap.get("pageNumber")
 
    this.channel = _ApiserviceService.getMovies(this.pageNumber).subscribe( (data)=>{  this.movies=data.results  })



  }



test($event:any){
 
 

   this.pageNumber=$event.target.innerHTML
  console.log("test="+this.pageNumber);
  this._ApiserviceService.getMovies(this.pageNumber).subscribe( (data)=>{

    window.scroll({
      top: 100,
      left: 100,
      behavior: 'smooth'
    });
    
    this.movies=data.results
    
    

  })
  
  
}

search($event:any){
   this._ApiserviceService.searchmovie($event.target.value).subscribe((data)=>{
    this.movies=data.results
  
  })


}


  ngOnInit(): void {

  

  }
  ngOnDestroy(){
    
// this.channel.unsubscrbe()


    
  }
}


